<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="containerBox" id="toTop">
        <div class="headerBox">
          <div class="top">
            <div class="searchBox" @click.stop="$router.push('/search')">
              <img class="searchIcon" src="@/assets/images/search_comm_icon@2x.png" />
              <span class="searchInput">请输入关键字搜索</span>
            </div>
          </div>
          <div class="classify">
            <div class="classify_content" ref="wrapper">
              <div class="classify_wrapper">
                <span :class="{'active_classify': departmentId == 0}" @click="changeDepartment(0, '')">
                  <template v-if="userInfo.Type != 3">全部</template>
                  <template v-if="userInfo.Type == 3">ALL</template>
                </span>
                <span :class="{'active_classify': departmentId == item.Id}" v-for="(item, index) in navBar" :key="index" @click="changeDepartment(item.Id, item.Code)">{{item.DisplayName}}</span>
              </div>
            </div>
            <div class="more">
              <router-link to="/interest">
                <img class="addIcon" src="@/assets/images/ellipsis.png" />
                <span>{{userInfo.Type != 3 ? '更多科室' : 'More'}}</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="content">
          <div id="dataList">
            <waterfall ref="waterfall" :col="1" :gutterWidth="0" :data="list">
              <template>
                <div class="list" v-for="(item, index) in list" :key="index" @click="toActivityDetails(item.Id)">
                  <img class="cover" :src="item.Thumbnail" />
                  <div class="info">
                    <p class="title van-multi-ellipsis--l2">{{ item.Title }}</p>
                    <p class="time">{{ item.StartTime | timeQuantum(item.EndTime) }}</p>
                  </div>
                </div>
              </template>
            </waterfall>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <div class="goback" @click="goback"><van-icon name="arrow-left" />返回直播</div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  name: 'ActivityList',
  data() {
    return {
      departmentId: 0,
      code: '',
      list: [],
      PageIndex: 0,
      PageSize: 6,
      Total: 0,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 6 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        },
			},
      scrollTop: 0,
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  watch: {
    navBar(newVal) {
      if(this.code && !newVal.some(obj => obj.Code == this.code)) {
        this.departmentId = 0;
        this.code = '';
        this.list = [];
        this.mescroll.resetUpScroll();
        this.miniProgramShare(this.departmentId, this.code);
      }
      this.$nextTick(() => {
        this.scroll.refresh();
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  created() {
    if(this.userInfo && this.userInfo.Id) {
      this.getNavbar();
    }
  },
  mounted() {
    this.initBScroll();
  },
  activated(){
    this.$refs.mescroll.$el.scrollTop = this.scrollTop;
    if(this.$route.query.code) {
      this.code = this.$route.query.code;
    }
    if(this.$route.query.id) {
      this.departmentId = this.$route.query.id;
    }
    this.miniProgramShare(this.departmentId, this.code);
    this.BuriedPoint(6, '活动列表', '', '/activityList?id=0');
  },
  methods: {
    // 初始化BScroll
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    // 获取列表数据
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetActivityList', {
          // SubCode: this.code,
          SubId: this.departmentId != 0 ? parseInt(this.departmentId) : null,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then((res) => {
          let arr = res.Data.List;
          this.Total = res.Data.Total;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = arr;
          let hasNext;
          if(arr.length < this.Total) {
            hasNext = true;
          } else {
            hasNext = false;
          }
          // this.list = this.list.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length, hasNext)
          })
        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr()
        })
      }, 200);
    },
    changeDepartment(id, code) {
      if(this.departmentId != id && this.code != code) {
        this.departmentId = id;
        this.code = code;
        this.miniProgramShare(this.departmentId, this.code);
        this.list = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      }
    },
    toActivityDetails(id) {
      this.scrollTop = this.$refs.mescroll.$el.scrollTop;
      this.$router.push({
        path: 'activityDetails',
        query: {
          id: id
        }
      });
    },
    miniProgramShare(id, code) {
      if(id && code) {
        wx.miniProgram.postMessage({
          data: {
            share: {
              title: '科室活动列表页',
              imageUrl: '',
              path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/activityList?id=${id}&&code=${code}`)}`,
              contentId: ''
            }
          }
        })
      } else {
        wx.miniProgram.postMessage({
          data: {
            share: {
              title: '活动列表页',
              imageUrl: '',
              path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + '/activityList?id=0')}`,
              contentId: ''
            }
          }
        })
      }
    },
    goback() {
      this.$router.push('/liveList?id=0');
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background-color: #F9F9F9;
  .headerBox {
    padding-top: 16px;
    background-color: #EB1701;
  }
  .mescroll {
    position: fixed;
    top: 0;
    bottom: 0;
    height: auto;
  }
  .top {
    margin-bottom: 10px;
    display: flex;
    padding: 0 12px;
    .menuIcon {
      width: 30px;
      height: 30px;
    }
    .searchBox {
      display: flex;
      align-items: center;
      flex: 1;
      height: 30px;
      line-height: 30px;
      border-radius: 30px;
      background-color: #FFFFFF;
      padding: 0 12px;
      .searchIcon {
        width: 16px;
        height: 16px;
      }
      .searchInput {
        flex: 1;
        margin-left: 5px;
        border: none;
        background-color: transparent;
        color: #999999;
      }
    }
  }
  .classify {
    display: flex;
    color: #FFFFFF;
    height: 31px;
    padding: 0 12px;
    .classify_content {
      display: flex;
      flex: 1;
      font-size: 14px;
      overflow: hidden;
      .classify_wrapper {
        white-space: nowrap;
        span {
          position: relative;
        }
        span:not(:last-child) {
          margin-right: 20px;
        }
        .active_classify {
          font-size: 18px;
          font-weight: bold;
        }
        .active_classify::after {
          content: "";
          width: 22px;
          height: 3px;
          border-radius: 3px;
          background-color: #FFFFFF;
          position: absolute;
          top: 24px;
          left: 50%;
          transform: translateX(-11px);
        }
      }
    }
    .more {
      font-size: 12px;
      margin-left: 10px;
      a {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        margin-top: 6px;
      }
      .addIcon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
      span {
        opacity: 0.8;
      }
    }
  }
  .content {
    min-height: 100%;
    margin-top: 1px;
    padding: 20px;
    background-color: #F9F9F9;
  }
  .content:before{
    content: '';
    display: table;
  }
  .list {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    .cover {
      display: block;
      width: 100%;
    }
    .info {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px 10px 10px;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
      color: #FFFFFF;
      .title {
        font-size: 15px;
        font-weight: bold;
        text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
      }
      .time {
        font-size: 10px;
      }
    }
  }
  .list:not(:last-child) {
    margin-bottom: 20px;
  }
  .goback {
    position: fixed;
    bottom: 250px;
    right: 0;
    width: 70px;
    height: 24px;
    border-radius: 24px 0 0 24px;
    line-height: 24px;
    text-align: center;
    background: linear-gradient(to right, #EB1700 0%, #C33BBB 60%, #8C3BBB 100%);
    font-size: 12px;
    color: #FFFFFF;
  }
}
</style>
